import { fromJS } from "immutable";
import * as ActionTypes from "../../actions/types";
import { loadConsent, saveConsent } from "./consentStorage";

const INITIAL_STATE = {
    consent: loadConsent(),     // null => show banner
    settingsOpen: false,
};

function openSettings(state) {
    return state.set("settingsOpen", true);
}

function closeSettings(state) {
    return state.set("settingsOpen", false);
}

function acceptAll(state) {
    const next = saveConsent({ performance: true, marketing: true, functional: true });
    return state.set("consent", fromJS(next));
}

function rejectNonEssential(state) {
    const next = saveConsent({ performance: false, marketing: false, functional: true });
    return state.set("consent", fromJS(next));
}

function savePreferences(state, action) {
    const { performance, marketing } = action.payload || {};
    const next = saveConsent({
        performance: !!performance,
        marketing: !!marketing,
        functional: true,
    });
    return state.set("consent", fromJS(next));
}


function bootstrap(state) {
    const next = loadConsent();
    return state.set("consent", next ? fromJS(next) : null);
}

const cookiesConsent = {
    initialState: INITIAL_STATE,
    handlers: {
        [ActionTypes.COOKIES_OPEN_SETTINGS]: openSettings,
        [ActionTypes.COOKIES_CLOSE_SETTINGS]: closeSettings,
        [ActionTypes.COOKIES_ACCEPT_ALL]: acceptAll,
        [ActionTypes.COOKIES_REJECT_NON_ESSENTIAL]: rejectNonEssential,
        [ActionTypes.COOKIES_SAVE_PREFERENCES]: savePreferences,
        [ActionTypes.COOKIES_BOOTSTRAP]: bootstrap,
    },
};

export default cookiesConsent;
